// Small hand-drawn icon set (24x24, stroke-based, currentColor) — kept in one
// file instead of an icon-library dependency since the app only needs ~10.
import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export function IconMark(props: IconProps) {
  // Brand mark: a ledger page with a folded corner and a rule — not a wallet/coin cliché.
  return (
    <svg {...base} {...props}>
      <path d="M5 3.5h10l4 4V20a.5.5 0 0 1-.5.5h-13A.5.5 0 0 1 5 20V4a.5.5 0 0 1 .5-.5Z" />
      <path d="M15 3.5V7a.5.5 0 0 0 .5.5H19" />
      <path d="M8 12h8M8 15.5h5" />
    </svg>
  );
}

export function IconRecover(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <circle cx="8.5" cy="8.5" r="4" />
      <path d="M11.3 11.3 20 20" />
    </svg>
  );
}

export function IconTrace(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <circle cx="6" cy="12" r="2.2" />
      <circle cx="14.5" cy="6" r="2.2" />
      <circle cx="14.5" cy="18" r="2.2" />
      <path d="M8 11.1 12.5 7.6M8 12.9l4.5 3.5" />
    </svg>
  );
}

export function IconDemo(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M9 3h6M10 3v5.2L5.6 17a1.6 1.6 0 0 0 1.4 2.4h10a1.6 1.6 0 0 0 1.4-2.4L14 8.2V3" />
      <path d="M7.5 14.5h9" />
    </svg>
  );
}

export function IconPuzzle(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M9 4.5h3.2a1 1 0 0 1 1 1.2 1.4 1.4 0 0 0 2.6.9 1 1 0 0 1 1.7.7V10a1 1 0 0 1-1.2 1 1.4 1.4 0 0 0-.9 2.6 1 1 0 0 1-.7 1.7H12a1 1 0 0 1-1-1.2 1.4 1.4 0 0 0-2.6-.9 1 1 0 0 1-1.7-.7V9.7a1 1 0 0 1 1.2-1 1.4 1.4 0 0 0 .9-2.6A1 1 0 0 1 9 4.5Z" />
    </svg>
  );
}

export function IconEdit(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M15.7 4.3a1.6 1.6 0 0 1 2.3 2.3L7.5 17.1 4 18l.9-3.5Z" />
      <path d="M13.5 6.5 16 9" />
    </svg>
  );
}

export function IconKey(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <circle cx="7.2" cy="14.8" r="3.3" />
      <path d="M9.5 12.5 17 5M14.5 7.5 17 5l2 2-2.2 2.2M12.2 10.2l2 2" />
    </svg>
  );
}

export function IconCompass(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <circle cx="12" cy="12" r="8" />
      <path d="M14.8 9.2 13 13l-3.8 1.8L11 11Z" />
    </svg>
  );
}

export function IconArrowDown(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M12 5v14M6 13l6 6 6-6" />
    </svg>
  );
}

export function IconArrowUp(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M12 19V5M6 11l6-6 6 6" />
    </svg>
  );
}

export function IconChat(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v7A2.5 2.5 0 0 1 17.5 16H10l-4.5 4v-4H6.5A2.5 2.5 0 0 1 4 13.5Z" />
      <path d="M8 9h8M8 12h5" />
    </svg>
  );
}

export function IconScale(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M12 3v3m0 0 5 10.5a3 3 0 0 1-5 1.7 3 3 0 0 1-5-1.7L12 6Z" />
      <path d="M4.5 6h15" />
    </svg>
  );
}
